export default __webpack_public_path__ + "locales/uk-UA/ArchiveDialog.json?hash=26c8fdc4a71c2464cfda319d3e6be27f";